import React from "react";
import backArrow from "../../assets/images/back.png";
import { useTranslation } from "react-i18next"; // ← ADD THIS

const CommonTitle = ({
  title,
  showBack = false,
  onBack,
  rightAction = null,
  titleClass = "",
  wrapperClass = "",
}) => {
  const { t } = useTranslation(); // ← ADD THIS

  const backButton = showBack && (
    <button
      onClick={onBack}
      className="flex items-center gap-2 text-blue-600 font-medium text-base hover:opacity-80 transition-opacity"
      aria-label="Go back"
    >
      <img src={backArrow} alt="" className="w-5 h-5 object-contain" />
      <span> {t("back")}</span>
    </button>
  );

  return (
    <div className={`text-black px-4 py-4 ${wrapperClass}`}>
      <div className="max-w-[1400px] mx-auto w-full">
        {/* ================= HEADER ROW ================= */}
        <div className="relative flex items-center w-full">
          {/* Back (always left) */}
          <div className="flex items-center z-10">{backButton}</div>

          {/* MOBILE TITLE (right aligned) */}
          {/* <div className="flex-1 text-right md:hidden">
            <h1 className={`text-lg font-semibold text-black ${titleClass}`}>
              {title}
            </h1>
          </div> */}

          <div className="flex-1 text-center md:hidden">
            <h1 className={`text-lg font-semibold text-black ${titleClass}`}>
              {title}
            </h1>
          </div>

          {/* WEB TITLE (centered) */}
          <div className="absolute inset-0 hidden md:flex items-center justify-center pointer-events-none">
            <h1 className={`text-2xl font-bold text-black ${titleClass}`}>
              {title}
            </h1>
          </div>

          {/* WEB Right actions */}
          <div className="hidden md:flex items-center ml-auto z-10">
            {rightAction}
          </div>
        </div>

        {/* ================= MOBILE ACTION ROW ================= */}
        {rightAction && (
          <div className="flex md:hidden justify-around items-center mt-4">
            {rightAction}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonTitle;
